import { supabase } from './supabase'

export const BADGES = {
  first_session:    { key: 'first_session',    name: 'First Session',     icon: '🥋' },
  sessions_10:      { key: 'sessions_10',      name: '10 Sessions',       icon: '🔥' },
  sessions_50:      { key: 'sessions_50',      name: '50 Sessions',       icon: '💪' },
  sessions_100:     { key: 'sessions_100',     name: '100 Sessions',      icon: '💯' },
  first_comp:       { key: 'first_comp',       name: 'First Competition', icon: '⚔️' },
  gold_medal:       { key: 'gold_medal',       name: 'Gold Medal',        icon: '🥇' },
  silver_medal:     { key: 'silver_medal',     name: 'Silver Medal',      icon: '🥈' },
  bronze_medal:     { key: 'bronze_medal',     name: 'Bronze Medal',      icon: '🥉' },
  triple_gold:      { key: 'triple_gold',      name: 'Triple Gold',       icon: '👑' },
  rising_star:      { key: 'rising_star',      name: 'Rising Star',       icon: '⭐' },
  elite:            { key: 'elite',            name: 'Elite',             icon: '🏆' },
}

export const COACH_BADGES = ['rising_star', 'elite']

async function hasBadge(fighter_id, badge_key) {
  const { data } = await supabase.from('fighter_badges')
    .select('id').eq('fighter_id', fighter_id).eq('badge_key', badge_key).limit(1)
  return data && data.length > 0
}

async function awardBadge(fighter_id, club_id, badge_key) {
  if (await hasBadge(fighter_id, badge_key)) return
  const b = BADGES[badge_key]
  await supabase.from('fighter_badges').insert({
    fighter_id, club_id, badge_key, badge_name: b.name, badge_icon: b.icon, auto: true
  })
}

async function awardPoints(fighter_id, club_id, points, reason, notes) {
  await supabase.from('fighter_points').insert({ fighter_id, club_id, points, reason, notes: notes || '' })
}

export async function onSessionCheckin(fighter, club_id) {
  const sessions = (fighter.sessions_count || 0) + 1
  await awardPoints(fighter.id, club_id, 1, 'session', 'Session #' + sessions)
  if (sessions === 1)   await awardBadge(fighter.id, club_id, 'first_session')
  if (sessions === 10)  await awardBadge(fighter.id, club_id, 'sessions_10')
  if (sessions === 50)  await awardBadge(fighter.id, club_id, 'sessions_50')
  if (sessions === 100) await awardBadge(fighter.id, club_id, 'sessions_100')
}

export async function onCompetitionResult(fighter_id, club_id, medal, tournament_name) {
  const medalPoints = { gold: 10, silver: 7, bronze: 5 }
  const pts = medalPoints[medal] || 5
  await awardPoints(fighter_id, club_id, pts, medal + '_medal', tournament_name)
  if (medal === 'gold')   await awardBadge(fighter_id, club_id, 'gold_medal')
  if (medal === 'silver') await awardBadge(fighter_id, club_id, 'silver_medal')
  if (medal === 'bronze') await awardBadge(fighter_id, club_id, 'bronze_medal')
  const { data } = await supabase.from('fighter_badges')
    .select('id').eq('fighter_id', fighter_id).eq('badge_key', 'gold_medal')
  if (data && data.length >= 3) await awardBadge(fighter_id, club_id, 'triple_gold')
  const { data: comps } = await supabase.from('competitions')
    .select('id').eq('fighter_id', fighter_id).limit(2)
  if (comps && comps.length <= 1) await awardBadge(fighter_id, club_id, 'first_comp')
}

export async function getFighterPoints(fighter_id) {
  const { data } = await supabase.from('fighter_points')
    .select('points').eq('fighter_id', fighter_id)
  return (data || []).reduce((sum, p) => sum + p.points, 0)
}
